export const languages = ['de', 'en', 'es', 'fr', 'it'];
